import React from "react";

export default function Positions({ positions }) {
  return (
    <div className="w-100 pt-4">
      <h5 className="fw-bold text-primary pb-3">Positions</h5>
      <div class="accordion w-100" id="accordionExample">
        {positions.map((item) => {
          return (
            <div class="accordion-item" key={item.position}>
              <h2 class="accordion-header">
                <button
                  class="accordion-button fw-semibold"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  {item.position}
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body">
                  <p
                    className="fw-semibold text-primary"
                    style={{ fontSize: "1.125rem" }}
                  >
                    Candidate must be:
                  </p>
                  <ul>
                    {item.qualifications.map((qualification) => {
                      return (
                        <li key={qualification}>
                          <p>{qualification}</p>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
